<template>
  <!-- eslint-disable-next-line vue-i18n/no-raw-text -->
  <div v-if="showButton" class="show-sirah-button" @click.prevent="$emit('showSirahClick')">&nbsp;</div>
  <div v-else class="show-sirah-button-filler"></div>
</template>

<script>
  export default {
    props: ['showButton'],
  };
</script>

<style lang="scss" scoped>
  @import "../../variables.scss";
  .show-sirah-button,
  .show-sirah-button-filler {
    width: 10px;
    display: flex;
    align-items: stretch;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
  }
  .show-sirah-button {
    cursor: pointer;
    background: $gray-300;
    &:hover {
      background: $gray-400;
    }
  }
</style>
